//
// $FlowFixMe
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Image = styled.img`
  width: 100%;
  object-fit: contain;
  height: auto;
  max-height: 600px;
`;
